import React, { memo } from 'react';
import TechnicalErrorPage from './TechnicalErrorPage';

const TechnicalError = memo(function TechnicalError() {
  return <TechnicalErrorPage />;
});

export default TechnicalError;
